import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import withOnline from '../../common/withOnline';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withUser from '../../common/withUser';
import withTeam from '../../common/withTeam';
import withServerUrl from '../../common/withServerUrl';
import {
  storeUser,
  userLogout,
  Fcm_Token,
  storeVersionCode
} from '../../common/globals';
import { reLogin } from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import { deleteOfflineSyncCases } from '../../utils/db';
import { APP_VERSION, REQUEST_SOURCE, APP_GENERATION } from '../../common/config';

class ChangeTeamDataConfirmation extends Component {
  _onClickYes = async () => {
    try {
      const {
        user, setUser, setTeam, setLoader, notify, team, online
      } = this.props;
      if (online) {
        setLoader(true);
        await deleteOfflineSyncCases();
        setTeam(team);
        const userData = Object.assign(user, { team: team.id, selectedTeam: team });
        setUser(userData);
        storeUser(userData);
        storeVersionCode();
        const reLoginData = {
          userId: user.loginPayload.userId,
          password: user.loginPayload.password,
          requestSource: REQUEST_SOURCE,
          lastAppVersion: APP_VERSION,
          appGeneration: APP_GENERATION,
          deviceId: 'website',
          deviceToken: '0',
          fcmToken: Fcm_Token
        };

        reLogin(reLoginData).then(async (response) => {
          setLoader(false);
          const { status } = response;
          if (status) {
            // Add office & team
            response.office = user.office;
            response.team = user.team;
            response.territoryId = user.territoryId;
            response.remember = user.remember;
            response.selectedTeam = user.selectedTeam;
            response.loginPayload = reLoginData;
            await storeUser(response);
            await storeVersionCode();
            setUser(response);
            browserHistory.push('/sync-data');
          } else {
            notify({ type: 'error', message: response.message });
            userLogout(false);
          }
        });
      } else {
        notify({ type: 'error', message: 'You must an internet connection to Log In. Please check your connection and try again.', time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    return (
      <div
        className="modal fade theme-modal" id="unSavedDataConfirmationModal"
        tabIndex="-1" aria-labelledby="unSavedDataConfirmationModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <p className="mb-0">You have cases with unsaved changes.</p>
              <p className="mb-0">These changes will be lost if you change team.</p>
              <p className="mb-0">Continue?</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-6">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal">No</button>
                </div>
                <div className="col-6">
                  <button
                    type="button" className="btn btn-gray w-100"
                    data-bs-dismiss="modal"
                    onClick={this._onClickYes}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTeam(
  withServerUrl(withUser(withOnline(withNotify(withLoader(ChangeTeamDataConfirmation)))))
);
